import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { isDarkTheme } from "segments/segments-service";
import { StyledMondayDemoMobileTimeline } from "./monday-demo-mobile-timeline.scss";
const MondayDemoMobileTimeline = (props)=>{
    const { tabs, selectedTab, wasComponentEverVisible, videoDuration, theme } = props;
    return /*#__PURE__*/ _jsx(StyledMondayDemoMobileTimeline, {
        className: classnames("monday-demo-tabs-timeline-and-labels-wrapper", {
            "dark-theme": isDarkTheme(theme)
        }),
        role: "tablist",
        children: tabs.map((tab, index)=>{
            const isSelected = index === selectedTab;
            return /*#__PURE__*/ _jsx("div", {
                className: classnames("timeline-tab-indication-label-and-progress-bar-wrapper", {
                    selected: isSelected && wasComponentEverVisible,
                    watched: index <= selectedTab
                }),
                children: index < tabs.length && /*#__PURE__*/ _jsx("div", {
                    className: "timeline-progress-bar-wrapper",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "timeline-progress-bar",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "timeline-progress-bar-empty"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "timeline-progress-bar-filled",
                                style: {
                                    animationDuration: index <= selectedTab ? `${videoDuration}s` : `unset`
                                }
                            })
                        ]
                    })
                })
            });
        })
    });
};
export default MondayDemoMobileTimeline;
